<template>
  <cardTemplate :classCustom="'detail job margin-top-10 margin-bottom-10'">
    <template #content>
      <div class="header flex-row flex__left">
        <div class="margin-right-10">
          <img src="../../assets/img/Work.svg" class="clickable" @click="$emit('viewMore')"/>
        </div>
        <div class="rightSection width__100 padding-bottom-10 has-border__bottom">
          <h3 class="tt1 clickable" @click="$emit('viewMore')">CÔNG VIỆC</h3>
          <span class="tt2">
            <span class="font-size__small">0 chờ xử lý</span>
            &nbsp;
            <el-tag
              type="success"
              class="priority"
              size="mini"
            >0 mới</el-tag>
          </span>
        </div>
      </div>
      <div class="body margin-bottom-10 margin-top-10">
        <VuePerfectScrollbar
          class="scroll-body"
          :settings="perfectScrollbarSetting"
        >
          <div class="stateEmpty flex-col flex__center">
            <img
              src="../../assets/img/nothing.jpg"
              class="icon-not-found margin-bottom-10 margin-top-10"
            />
            <span class="font-size__small opacity-50">Không có dữ liệu</span>
          </div>
        </VuePerfectScrollbar>
        <div class="more clickable txt-center" @click="$emit('viewMore')">XEM THÊM</div>
      </div>
    </template>
  </cardTemplate>
</template>

<script>
  export default {
    name: "CongViecCard",
    components: {
      cardTemplate: () => import('../common/cardTemplate.vue'),
      VuePerfectScrollbar: () => import("vue-perfect-scrollbar"),
    },
    data() {
      return {
        perfectScrollbarSetting: {maxScrollbarLength: 350},
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/dashboard/CongViecCard.vue